import { debounce } from 'lodash-es';
import * as React from 'react';

export function useDebounce<T>(fn: (value: T) => void, time: number = 500) {
    return React.useCallback(debounce(fn, time), []);
}
